import { HTTP } from '@/services/axios';

export async function getMenuItems({filterText,orderCol,orderSort,page,records}){
    let result = {};
    
    await HTTP.get('/app/core/MenuItem/getMenuItemList.php',{
        params:{
            filterText,
            orderCol,
            orderSort,
            page,
            records
        }
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function getMenuItem({menuItemId}){
    let result = {};
   
    await HTTP({
        method: 'get',
        url: `/app/core/MenuItem/getMenuItemData.php?menuItemId=${menuItemId}`,
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });
    return result;
}

export async function unlockMenuItem({menuItemId}){
    let result = {};

    var data = {'myRecordID':menuItemId};
    
    await HTTP({
        method: 'patch',
        url: '/app/core/MenuItem/controlMenuItemUnlock.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function getMemuItemOptions(){
    let result = {};
    var bodyFormData = new FormData();
    
    await HTTP({
        method: 'get',
        url: '/app/core/MenuItem/getMemuItemOptions.php',
        data: bodyFormData
    })
    .then(response => {
        console.log(response.data)
        result = response.data.result;
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function createMenuItem({data}){
    let result = {};

    await HTTP({
        method: 'post',
        url: '/app/core/MenuItem/controlMenuItemSave.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function saveMenuItem({data}){
    let result = {};

    await HTTP({
        method: 'put',
        url: '/app/core/MenuItem/controlMenuItemSave.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function deleteMenuItem({data}){
    let result = {};

    await HTTP({
        method: 'delete',
        url: '/app/core/MenuItem/controlMenuItemDelete.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}